module.exports = __webpack_public_path__ + "static/img/lightning.e82f9bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/lightning.jpg
// module id = qCzj
// module chunks = 1